import React, { useEffect, useState } from 'react';
import { INavStyles, INavLinkGroup } from '@fluentui/react/lib/Nav';
import { BwjNav } from '../../framework/components/bwj-nav';
/*@begin-app-target*/import { AppLinks } from '../../app-admin/app-links';/*@end-app-target*/
import { useEventNotification } from '../../framework/services/event-notification';
import { AppMenuEvents } from '../../events/app-menu';
import { getTheme, IStyle, mergeStyleSets, PanelType } from '@fluentui/react';
import { BwjSidePanel } from '../../framework/components/bwj-side-panel';

interface IAppSideNavProps {
  title: string;
  invokeShowMobileNav: {} | undefined;
  showDesktopNav: boolean;
}

const getStyleClasses = () => {
  const desktopMenu: IStyle = {
    display: 'none',
    width: 220,
    height: '100%',

    '& > .ms-FocusZone': {
      height: '100%',
    },

    '@media(min-width: 501px)': {
      display: 'block',
    },
  };

  return mergeStyleSets({
    desktopMenu,
  });
};

const getNavStyles = (): Partial<INavStyles> => {
  const theme = getTheme();
  return {
    root: {
      width: '100%',
      height: '100%',
      boxSizing: 'border-box',
      border: 'none',
      backgroundColor: theme.palette.neutralLighter,
      overflowY: 'auto',
    },
    // these link styles override the default truncation behavior
    link: {
      lineHeight: 'inherit',
    },
  };
};

const navLinkGroups: INavLinkGroup[] = [
  {
    links: [
      ...AppLinks
    ],
  },
];

const subscriberId = 'Component.AppSideNav';

export const AppSideNav: React.FunctionComponent<IAppSideNavProps> = (props) => {
  const { invokeShowMobileNav } = props;
  const [selectedKey, setSelectedKey] = useState('none');
  const [showMobileNav, setShowMobileNav] = useState(false);
  const styles = getStyleClasses();
  const navStyles = getNavStyles();

  useEventNotification((key: string) => setSelectedKey(key), [], AppMenuEvents.ChangeSelectedLink, subscriberId);

  useEffect(() => {
    setShowMobileNav(invokeShowMobileNav !== undefined);
  }, [invokeShowMobileNav]);

  return (
    <>
      <BwjSidePanel
        showPanel={showMobileNav}
        title={props.title}
        panelType={PanelType.smallFixedNear}
        onDismiss={() => setShowMobileNav(false)}
        closeButtonAriaLabel={'Close main menu'}
      >
        <BwjNav
          selectedKey={selectedKey}
          ariaLabel={'Main menu'}
          styles={navStyles}
          groups={navLinkGroups}
          onLinkClick={() => setShowMobileNav(false)}
        />
      </BwjSidePanel>
      {props.showDesktopNav &&
      <div className={styles.desktopMenu}>
        <BwjNav
          selectedKey={selectedKey}
          ariaLabel={'Main menu'}
          styles={navStyles}
          groups={navLinkGroups}
        />
      </div>}
    </>
  );
};
